"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityForm',
  props: {
    formData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      realImages: [],
      backgroundImages: [],
      merchantImages: [],
      merchantImageList: [],
      // 存储图片相对路径
      realImagePath: '',
      backgroundImagePath: '',
      rules: {}
    };
  },
  methods: {
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传一张图片，新图片将替换原有图片');
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB！');
        return false;
      }
      return true;
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.$emit('preview-image', file);
    },
    /**
     * 通用图片上传：立即上传获取相对路径，更新 formData
     */
    doUpload: function doUpload(raw, field, listKey, defaultName, uploadPath) {
      var _this = this;
      this[listKey] = [{
        name: defaultName,
        url: URL.createObjectURL(raw)
      }];
      (0, _shopList.uploadImage)(raw, uploadPath).then(function (res) {
        var relativePath = res.data;
        _this[listKey] = [{
          name: defaultName,
          url: (0, _shopList.getImageUrl)(relativePath)
        }];
        _this.$emit('update:formData', _objectSpread(_objectSpread({}, _this.formData), {}, (0, _defineProperty2.default)({}, field, relativePath)));
      }).catch(function () {
        // 上传失败恢复
        _this.syncFileList(listKey, _this.formData[field], defaultName);
        _this.$message.error('图片上传失败');
      });
    },
    /**
     * 同步图片列表：将 dbPath 转为 el-upload fileList 格式
     */
    syncFileList: function syncFileList(listKey, dbPath, defaultName) {
      if (dbPath && dbPath !== '') {
        this[listKey] = [{
          name: defaultName,
          url: (0, _shopList.getImageUrl)(dbPath)
        }];
      } else {
        this[listKey] = [];
      }
    },
    // ---- 封面图 ----
    handleRemoveReal: function handleRemoveReal(file, fileList) {
      this.realImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        liveSceneImgUrl: ''
      }));
    },
    handleRealImageChange: function handleRealImageChange(file) {
      this.doUpload(file.raw, 'liveSceneImgUrl', 'realImages', '封面图', '/realImage/');
    },
    // ---- 背景图 ----
    handleRemoveBackground: function handleRemoveBackground(file, fileList) {
      this.backgroundImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        backgroundImgUrl: ''
      }));
    },
    handleBackgroundImageChange: function handleBackgroundImageChange(file) {
      this.doUpload(file.raw, 'backgroundImgUrl', 'backgroundImages', '背景图', '/backgroundImage/');
    },
    // ---- 细节图 ----
    handleRemoveMerchant: function handleRemoveMerchant(file, fileList) {
      this.merchantImages = fileList;
      // item.name 存的是相对路径（initForm 中用 detailImg 赋值，上传时用 relativePath 赋值）
      this.merchantImageList = fileList.map(function (item) {
        return item.name;
      });
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        merchantImageList: this.merchantImageList
      }));
    },
    handleMerchantImageChange: function handleMerchantImageChange(file) {
      var _this2 = this;
      var raw = file.raw;
      // 先展示本地预览
      this.merchantImages = [].concat((0, _toConsumableArray2.default)(this.merchantImages), [{
        name: file.name,
        url: URL.createObjectURL(raw)
      }]);
      (0, _shopList.uploadImage)(raw, '/detailImg/').then(function (res) {
        var relativePath = res.data;
        _this2.merchantImageList = [].concat((0, _toConsumableArray2.default)(_this2.merchantImageList), [relativePath]);
        // name 存相对路径，用于删除时取回
        _this2.merchantImages = [].concat((0, _toConsumableArray2.default)(_this2.merchantImages.slice(0, -1)), [{
          name: relativePath,
          url: (0, _shopList.getImageUrl)(relativePath)
        }]);
        _this2.$emit('update:formData', _objectSpread(_objectSpread({}, _this2.formData), {}, {
          merchantImageList: _this2.merchantImageList
        }));
      }).catch(function () {
        // 上传失败移除本地预览
        _this2.merchantImages = _this2.merchantImages.filter(function (item) {
          return item.name !== file.name;
        });
        _this2.$message.error('细节图上传失败');
      });
    },
    initForm: function initForm() {
      this.syncFileList('realImages', this.formData.liveSceneImgUrl, '封面图');
      this.syncFileList('backgroundImages', this.formData.backgroundImgUrl, '背景图');
      if (this.formData.merchantImages != null) {
        this.merchantImages = this.formData.merchantImages.map(function (item) {
          return {
            name: item.detailImg,
            url: (0, _shopList.getImageUrl)(item.detailImg)
          };
        });
        this.merchantImageList = this.formData.merchantImages.map(function (item) {
          return item.detailImg;
        });
      }
    }
  },
  mounted: function mounted() {
    this.initForm();
  },
  watch: {
    'formData.liveSceneImgUrl': {
      handler: function handler(newVal) {
        if (newVal) this.syncFileList('realImages', newVal, '封面图');
      },
      immediate: true
    },
    'formData.backgroundImgUrl': {
      handler: function handler(newVal) {
        if (newVal) this.syncFileList('backgroundImages', newVal, '背景图');
      },
      immediate: true
    }
  }
};